<template>
  <h1 class="font-bold text-3xl mb-4">Create an account</h1>

  <FormKit type="form" @submit="handleSubmit" submit-label="Sign Up">
    <FormKit type="email" name="email" placeholder="Email"></FormKit>
    <FormKit
      name="password"
      suffix-icon="eyeClosed"
      @suffix-icon-click="handlePasswordToggle"
      suffix-icon-class="hover:text-blue-500"
      type="password"
      placeholder="Password"
    ></FormKit>
  </FormKit>
  If you already have an account <RouterLink to="login" class="text-secondary font-bold">login here</RouterLink>
</template>

<script setup lang="ts">
import { type FormKitNode } from '@formkit/core'
import { useLsGeneralStore } from '../stores/application'
import { useRouter } from 'vue-router'

const handlePasswordToggle = (node: FormKitNode) => {
  node.props.suffixIcon = node.props.suffixIcon === 'eye' ? 'eyeClosed' : 'eye'
  node.props.type = node.props.type === 'password' ? 'text' : 'password'
}

const store = useLsGeneralStore()
const router = useRouter()

const handleSubmit = async (d: { email: string; password: string }) => {
  await store.registerAccount(d)
  router.push({ name: 'registration_success' })
}
</script>
